import {removeFromStorage, saveToStorage} from '@/helpers/storage';
import {AppState} from "@/store/index";
import BuildingMeters from "@/data/models/building-meters";
import {AuthUser} from "@/data/models/auth-session";

export default {
  applicationStarted(state: AppState): void {
    state.applicationStarted = true;
  },
  setUser(state: AppState, user: AuthUser | null): void {
    if (user == null) {
      state.currentUserBuildings = [];
      removeFromStorage('currentUserBuildings');
    }
    state.currentUser = user;
  },
  setUserBuildings(state: AppState, buildings: BuildingMeters[]): void {
    saveToStorage('currentUserBuildings', buildings);
    state.currentUserBuildings = buildings;
  },
  setIsLimited(state: AppState, isLimited: boolean): void {
    state.isLimited = isLimited;
  },
  setIsAdmin(state: AppState, isAdmin: boolean): void {
    state.isAdmin = isAdmin;
  },
  setBreadCrumbName(state: AppState, value: string): void {
    state.breadcrumbName = value;
  },
  setBreadCrumbBuilding(state: AppState, value: string): void {
    state.breadcrumbBuilding = value;
  },
  setBreadCrumbMeter(state: AppState, value: string): void {
    state.breadcrumbMeter = value;
  },
  showLoader(state: AppState, active: boolean): void {
    state.loading = active;
  }
}
;
